import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@hub-la/shadcn'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface LoadingAlertModalProps {
  onClose: () => void
  open: boolean
}

export const LoadingAlertModal: React.FC<LoadingAlertModalProps> = ({ onClose, open }) => {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-semibold">{t('loadingAlertModal.title')}</DialogTitle>
          <DialogDescription className="text-base">{t('loadingAlertModal.description')}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-end">
          <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
            <Button onClick={onClose} type="button">
              {t('loadingAlertModal.stay')}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
